module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Hinzufügen","addSupplier":"Lieferant hinzufügen","back":"Zurück","pleaseCompleteTheForm":"Bitte vervollständigen Sie Ihre Angaben."},"en":{"add":"Add","addSupplier":"Add supplier","back":"Back","pleaseCompleteTheForm":"Please complete the form."}}')
  delete Component.options._Ctor
}
